import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "pophead"
};
const _hoisted_2 = {
  class: "phleft"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "popcontent"
};
const _hoisted_5 = {
  class: "popconleft"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "popconright"
};
const _hoisted_8 = {
  class: "innerbox"
};
const _hoisted_9 = {
  class: "imgcontent"
};
const _hoisted_10 = {
  class: "swiper-wrapper"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "swiper-button-next"
};
const _hoisted_13 = {
  class: "swiper-button-prev"
};
const _hoisted_14 = {
  class: "otherdesc"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
const _hoisted_17 = ["href"];
const _hoisted_18 = {
  class: "textcontainer"
};
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  class: "innerbox"
};
const _hoisted_21 = {
  key: 0,
  class: "ul2"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  href: "javascript:void(0)"
};
const _hoisted_24 = {
  class: "imgbox"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  key: 1,
  class: "innerdetail"
};
const _hoisted_27 = {
  class: "videobox"
};
const _hoisted_28 = ["src", "poster"];
const _hoisted_29 = {
  key: 2,
  class: ""
};
const _hoisted_30 = {
  class: "innerbox"
};
const _hoisted_31 = {
  key: 0,
  class: "ul1"
};
const _hoisted_32 = {
  class: "audiobox"
};
const _hoisted_33 = {
  key: 1,
  class: ""
};
const _hoisted_34 = {
  class: "funbox"
};
const _hoisted_35 = {
  key: 0,
  class: "li4"
};
const _hoisted_36 = {
  key: 1,
  class: "li2"
};
const _hoisted_37 = {
  key: 2,
  class: "li3"
};
const _hoisted_38 = {
  key: 3,
  class: "li1"
};
const _hoisted_39 = {
  key: 4,
  class: "li1"
};
const _hoisted_40 = {
  key: 5,
  id: "audiodesc",
  style: {
    "width": "0",
    "height": "0"
  }
};
const _hoisted_41 = ["src"];
const _hoisted_42 = ["src", "poster"];
const _hoisted_43 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_vue_audio = _resolveComponent("vue-audio");
  const _component_Microphone = _resolveComponent("Microphone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Mute = _resolveComponent("Mute");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style3", [{
      'mobile': _ctx.$attrs.isMobile
    }, {
      'useSvw': _ctx.$attrs.id === 1
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$attrs.detail.place_name), 1)]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, [...(_cache[9] || (_cache[9] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.popLeftIndex === item.id
      }),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_6);
  }), 128))])]), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      'on': _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_11), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(i + 1), 1), _cache[10] || (_cache[10] = _createTextVNode("/", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.banner.length), 1)])]);
  }), 128))]), _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [[_vShow, _ctx.$attrs.isMobile]]), _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [[_vShow, _ctx.$attrs.isMobile]])], 2)], 512), [[_vShow, _ctx.$attrs.detail.banner && _ctx.$attrs.detail.banner.length > 0]]), _createElementVNode("div", _hoisted_14, [_ctx.$attrs.detail.route && _ctx.$attrs.detail.route.length > 0 && Object.keys(_ctx.$attrs.detail.route[0]).length > 1 ? (_openBlock(), _createElementBlock("p", _hoisted_15, [_cache[11] || (_cache[11] = _createElementVNode("span", {
    class: "icon-location1"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($options.getAddress(_ctx.$attrs.detail.route)), 1)])) : _createCommentVNode("", true), _ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_16, [_createElementVNode("a", {
    href: `tel:${_ctx.$attrs.detail.telphone}`
  }, [_cache[12] || (_cache[12] = _createElementVNode("span", {
    class: "icon-tel"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)], 8, _hoisted_17)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: _ctx.$attrs.detail.introduce
  }, null, 8, _hoisted_19)])], 512), [[_vShow, $data.popLeftIndex === 0]]), _withDirectives(_createElementVNode("div", _hoisted_20, [_ctx.$attrs.detail.video !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.video, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.videoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl),
      alt: ""
    }, null, 8, _hoisted_25)]), _createElementVNode("h2", null, _toDisplayString(item.title), 1)])], 8, _hoisted_22);
  }), 128))])) : _createCommentVNode("", true), $data.videoitemflag && $data.videoitem !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _createElementVNode("h2", null, _toDisplayString($data.videoitem.title), 1), _createElementVNode("div", _hoisted_27, [!_ctx.$attrs.direction && $data.videoitem ? (_openBlock(), _createElementBlock("video", {
    key: 0,
    src: $data.videoitem.url,
    controls: "",
    poster: $options.sethandleHttp($data.videoitem.fileUrl)
  }, null, 8, _hoisted_28)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.video === '' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 2]]), _withDirectives(_createElementVNode("div", _hoisted_30, [_ctx.$attrs.detail.audio !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.audio, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_32, [_createVNode(_component_vue_audio, {
      file: item.url
    }, null, 8, ["file"])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audio === '' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 3]])])]), _createElementVNode("ul", _hoisted_34, [_ctx.$attrs.detail.portal_link ? (_openBlock(), _createElementBlock("li", _hoisted_35, [_createElementVNode("a", {
    onClick: _cache[2] || (_cache[2] = $event => $options.goLink(_ctx.$attrs.detail.portal_link))
  }, [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
    class: "icon-home"
  }, null, -1), _createTextVNode("门户", -1)]))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtual_link ? (_openBlock(), _createElementBlock("li", _hoisted_36, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.goLink(_ctx.$attrs.detail.virtual_link))
  }, [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
    class: "icon-360"
  }, null, -1), _createTextVNode("全景", -1)]))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.special_link ? (_openBlock(), _createElementBlock("li", _hoisted_37, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => $options.goLink(_ctx.$attrs.detail.special_link))
  }, [...(_cache[16] || (_cache[16] = [_createElementVNode("span", {
    class: "icon-topic"
  }, null, -1), _createTextVNode("专题", -1)]))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.route.length > 0 && _ctx.$attrs.detail.route[0].lng && $data.daohangflag ? (_openBlock(), _createElementBlock("li", _hoisted_38, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLocation(_ctx.$attrs.detail))
  }, [...(_cache[17] || (_cache[17] = [_createElementVNode("span", {
    class: "icon-location"
  }, null, -1), _createTextVNode("导航", -1)]))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.audiodesc && _ctx.$attrs.detail.audiodesc.length > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_39, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = (...args) => $options.playaudiodesc && $options.playaudiodesc(...args))
  }, [_withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Microphone)]),
    _: 1
  }, 512), [[_vShow, !$data.audiodescflag]]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Mute)]),
    _: 1
  }, 512), [[_vShow, $data.audiodescflag]]), _cache[18] || (_cache[18] = _createTextVNode("语音", -1))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.audiodesc && _ctx.$attrs.detail.audiodesc.length > 0 ? (_openBlock(), _createElementBlock("audio", _hoisted_40, [_createElementVNode("source", {
    src: _ctx.$attrs.detail.audiodesc[0].url
  }, null, 8, _hoisted_41), _cache[19] || (_cache[19] = _createTextVNode(" 您的浏览器不支持 audio 元素。 ", -1))])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _ctx.$attrs.isMobile && _ctx.$attrs.direction && $data.videoitem ? (_openBlock(), _createElementBlock("video", {
    key: 1,
    id: "dsvideo",
    ref: "dsvideo",
    src: $data.videoitem.url,
    poster: $options.sethandleHttp($data.videoitem.fileUrl),
    "x5-playsinline": "true",
    playsinline: "true",
    "webkit-playsinline": "true",
    "x-webkit-airplay": "true",
    style: _normalizeStyle($data.videoStyle),
    oncontextmenu: "return false"
  }, null, 12, _hoisted_42)) : _createCommentVNode("", true), _ctx.$attrs.isMobile && _ctx.$attrs.direction && $data.videoitem && $data.playbtn ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "videoplay",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.videoplay && $options.videoplay(...args))
  }, [...(_cache[20] || (_cache[20] = [_createElementVNode("span", {
    class: "icon-video"
  }, null, -1)]))])) : _createCommentVNode("", true), _ctx.$attrs.isMobile && _ctx.$attrs.direction && $data.videoitem ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "videoclose",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, [...(_cache[21] || (_cache[21] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_43), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("返回", -1)]))]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}